module.exports = __webpack_public_path__ + "img/Logos_Ajuntaments_260x260-CR.7464f515.png";